module.exports = __webpack_public_path__ + "img/top-banner.e0e0af78.jpg";